var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccurenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    fill: "none",
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.15 21.75 6.7 19.3l-2.75-.6a.94.94 0 0 1-.6-.388.93.93 0 0 1-.175-.687L3.45 14.8l-1.875-2.15a.93.93 0 0 1-.25-.65q0-.375.25-.65L3.45 9.2l-.275-2.825a.93.93 0 0 1 .175-.688.94.94 0 0 1 .6-.387l2.75-.6 1.45-2.45a.986.986 0 0 1 1.25-.4l2.6 1.1 2.6-1.1a.97.97 0 0 1 .7-.038.98.98 0 0 1 .55.438L17.3 4.7l2.75.6q.375.075.6.388.226.313.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825a.93.93 0 0 1-.175.688.94.94 0 0 1-.6.387l-2.75.6-1.45 2.45a.985.985 0 0 1-1.25.4l-2.6-1.1-2.6 1.1a.97.97 0 0 1-.7.038.98.98 0 0 1-.55-.438m1.3-1.8 2.55-1.1 2.6 1.1 1.4-2.4 2.75-.65-.25-2.8 1.85-2.1-1.85-2.15.25-2.8-2.75-.6-1.45-2.4L12 5.15l-2.6-1.1L8 6.45l-2.75.6.25 2.8L3.65 12l1.85 2.1-.25 2.85 2.75.6zM12 17a.97.97 0 0 0 .713-.288A.96.96 0 0 0 13 16a.97.97 0 0 0-.288-.713A.96.96 0 0 0 12 15a.97.97 0 0 0-.713.288A.96.96 0 0 0 11 16q0 .425.288.713.289.288.712.287m0-4a.97.97 0 0 0 .713-.288A.96.96 0 0 0 13 12V8a.97.97 0 0 0-.288-.713A.96.96 0 0 0 12 7a.97.97 0 0 0-.713.288A.96.96 0 0 0 11 8v4q0 .425.288.713.289.288.712.287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccurenceIcon);
export default __webpack_public_path__ + "static/media/occurenceIcon.28514eb066b96b6239b3be50577f76fe.svg";
export { ForwardRef as ReactComponent };